import {
  PaymentMethodDeleteManyRequestType,
  PaymentMethodDeleteManyResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePaymentMethodDeleteMany = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PaymentMethodDeleteManyRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `payment-method/delete-many`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as PaymentMethodDeleteManyResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.PaymentMethods],
      });
    },
  });
};
